<h1 mat-dialog-title>Change State</h1>
<div mat-dialog-content>
  <p>You are changing the {{data.type}} state of {{data.booth.name}}</p>
  <div class="row">
    <div class="col-6">
      <mat-form-field>
        <mat-label>New State</mat-label>
        <mat-select [value]="newState">
          <mat-option *ngFor="let state of states" [value]="state">
            {{state}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field>
        <mat-label>Prefill Comment</mat-label>
        <mat-select (selectionChange)="this.prefill($event.source)">
          <mat-option *ngFor="let state of comments" [value]="state">
            {{state}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <mat-form-field style="width: 100%">
        <mat-label>Comment (optional)</mat-label>
        <textarea matInput style="height: 100px;" [(ngModel)]="comment">

    </textarea>
      </mat-form-field>
    </div>
  </div>
  <div style="width: 100%; display: flex; justify-content: end;">
    <button [disabled]="newState === undefined" (click)="submit()" mat-raised-button color="primary">Submit</button>
  </div>


</div>
